const HEX_COLOR_REGEX =
  /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{4}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/;

const clamp = (value: number, min: number, max: number) =>
  Math.min(max, Math.max(min, value));

const expandShorthandHex = (hex: string) =>
  hex
    .split("")
    .map(char => `${char}${char}`)
    .join("");

const alphaToHex = (alpha: number) =>
  Math.round(clamp(alpha, 0, 1) * 255)
    .toString(16)
    .padStart(2, "0")
    .toUpperCase();

/**
 * Applies an alpha channel to a hex color.
 *
 * Supports `#RGB`, `#RGBA`, `#RRGGBB`, and `#RRGGBBAA`.
 * Non-hex colors are returned unchanged.
 */
export const withAlpha = (color: string, alpha: number): string => {
  if (!HEX_COLOR_REGEX.test(color)) {
    return color;
  }

  const value = color.slice(1);
  const expanded =
    value.length === 3 || value.length === 4
      ? expandShorthandHex(value)
      : value;
  const rgb = expanded.slice(0, 6);

  return `#${rgb}${alphaToHex(alpha)}`;
};
